<div class="p-6">
  <span class="d-flex justify-content-between udex-mb-22">
      <div class="title udex-mb-20">
        <h2 class="heading__medium--xs">
          {{ ('ctaForm.title' | cxTranslate) }}
        </h2>
      </div>
      <div
        data-cy="close-button"
        [attr.aria-label]="'configurator.closeModalLabel' | cxTranslate"
        class="ms-auto d-flex focusable"
        tabindex="0"
        (click)="close()"
        (keyup.enter)="close()"
      >
      <div>
        <em
          class="focusable__element ds-cursor--pointer ds-color--grey-2 ds-icon--close ds-icon--medium"
        ></em>
      </div>
    </div>
  </span>
  <div class="body--m udex-mb-20">
    <span>
      {{ ('ctaForm.subTitle' | cxTranslate : {name: product.name}) }}
    </span>
  </div>
  <ng-container *ngFor="let slmTransactionType of sortedSlmTransactionTypes$ | async">
    <dcp-cta-info-page-cta-button
      [slmTransactionType]="slmTransactionType"
      [bundleTemplate]="bundleTemplate"
      [product]="product">
    </dcp-cta-info-page-cta-button>
  </ng-container>
  <div class="udex-mt-32">
    <!-- static MANAGE_ORDERS -->
    <dcp-cta-info-page-cta-link
      [slmTransactionType]="{
      code: MANAGE_ORDERS,
      actionType: 'navigation',
      targetUrl: configService.getString('urls.sap4me') + manageOrdersUrl
    }"
      [bundleTemplate]="bundleTemplate"
      [product]="product">
    </dcp-cta-info-page-cta-link>
    <!-- static SUPPORT_FORM -->
    <dcp-cta-info-page-cta-link
      [slmTransactionType]="{code: CONTACT_SUPPORT, actionType: 'supportForm'}"
      [bundleTemplate]="bundleTemplate"
      [product]="product">
    </dcp-cta-info-page-cta-link>
  </div>
</div>
